import axiosStatic from 'axios';

import { config } from '../config';

export const axios = axiosStatic.create({
    baseURL: config.apiUrl
});

axios.interceptors.request.use(async requestConfig => {
    if (requestConfig.url?.startsWith('/') && requestConfig.url !== '/user_token') {
        try {
            const authToken = localStorage.authToken;
            requestConfig.headers.Authorization = `Bearer ${authToken}`;
        } catch (e) {
            // if the error is ClientAuthError, we do NOT want to throw
            // instead, perform the request without an Authorization header
            if ((e).name !== "ClientAuthError") {
                throw e;
            }
        }
    }
    return requestConfig;
});

axios.interceptors.response.use(async response => {
    return response;
});

export class AxiosService {
    static staticAxios = axios;

    get axios() {
        return AxiosService.staticAxios;
    }
}
